import {addToast} from '@heroui/react';

const DEFAULT_ERROR = 'خطایی رخ داد. لطفاً دوباره تلاش کنید.';

const TITLES = {
    success: 'موفق',
    danger: 'خطا',
    warning: 'توجه',
};

function toastClassNames(type) {
    const accent =
        type === 'success'
            ? 'border-s-4 border-s-success_main'
            : type === 'warning'
                ? 'border-s-4 border-s-Secondary-950'
                : 'border-s-4 border-s-Primary-900';

    const iconBg =
        type === 'success'
            ? 'bg-green-50 text-success_main'
            : type === 'warning'
                ? 'bg-Secondary-50 text-Secondary-950'
                : 'bg-Primary-50 text-Primary-900';

    const progress =
        type === 'success'
            ? 'bg-success_main'
            : type === 'warning'
                ? 'bg-Secondary-950'
                : 'bg-gradient-to-l from-Secondary-950 to-Primary-900';

    return {
        base: [
            'rest-toast',
            accent,
            '!bg-white',
            'border border-[#ebe2d9]',
            'shadow-[0_12px_32px_rgba(45,33,24,0.12)]',
            'rounded-xl',
            'min-w-[18rem]',
            'max-w-[24rem]',
            'overflow-hidden',
        ].join(' '),
        wrapper: 'gap-3 items-start',
        title: 'text-[#2d2118] font-extrabold text-sm leading-6',
        description: 'text-[#5c4a3d] text-sm leading-relaxed',
        icon: ['rest-toast__icon', iconBg, 'rounded-lg'].join(' '),
        closeButton: 'rest-toast__close text-[#9a8578] hover:text-[#5c4a3d]',
        progressTrack: 'h-1 !bg-[#f3ebe3]',
        progressIndicator: ['h-1', progress].join(' '),
    };
}

export function getErrorMessage(error, fallback = DEFAULT_ERROR) {
    const data = error?.response?.data;

    if (data?.errors && typeof data.errors === 'object') {
        const firstKey = Object.keys(data.errors)[0];
        const firstMessage = data.errors[firstKey]?.[0];
        if (firstMessage) {
            return firstMessage;
        }
    }

    if (typeof data?.message === 'string' && data.message && data.message !== 'The given data was invalid.') {
        return data.message;
    }

    const status = error?.response?.status;
    if (status === 422) {
        return 'اطلاعات وارد شده نامعتبر است.';
    }
    if (status >= 500) {
        return 'خطای سرور رخ داد. لطفاً دوباره تلاش کنید.';
    }

    if (typeof error?.message === 'string' && !/^Request failed with status code \d+$/i.test(error.message)) {
        return error.message;
    }

    return fallback;
}

function showToast(type, description, options = {}) {
    const {title, timeout, ...rest} = options;

    addToast({
        title: title ?? TITLES[type],
        description,
        color: type,
        severity: type === 'danger' ? 'danger' : type === 'warning' ? 'warning' : 'success',
        variant: 'bordered',
        radius: 'lg',
        timeout: timeout ?? 4500,
        shouldShowTimeoutProgress: true,
        classNames: toastClassNames(type),
        ...rest,
    });
}

export function toastSuccess(description, options) {
    showToast('success', description, options);
}

export function toastError(description, options) {
    showToast('danger', description, options);
}

export function toastWarning(description, options) {
    showToast('warning', description, options);
}
